import { gql } from "@apollo/client";

const DOWNLOAD_QUERY = gql`
  query download($id: String!) {
    download(id: $id) {
      id
      created
      finished
      handle
      purpose
      progress
      report_datetime {
        short
        long
        long_utc
        iso
      }
      source_tables {
        name
        project
      }
      started
      status
      parts {
        id
        dirty_row_count
        dirty_row_status
        legacy_flow_source_id
        row_count
        source_table {
          name
          project
        }
        hasConnectedUploadDeclarations
      }
    }
  }
`;

const DOWNLOADS_FOR_FLOW_SE_QUERY = gql`
  query flow_downloads($id: String!) {
    flow_downloads(id: $id) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          created
          finished
          handle
          purpose
          progress
          report_datetime {
            short
            long
            long_utc
            iso
          }
          source_tables {
            name
            project
          }
          started
          status
          parts {
            id
            dirty_row_count
            dirty_row_status
            legacy_flow_source_id
            row_count
            source_table {
              name
              project
            }
          }
        }
      }
    }
  }
`;

const DOWNLOAD_FILES_QUERY = gql`
  query downloads(
    $dirty: Boolean
    $dirtyEqualsNewDirty: Boolean
    $newDirtyGreaterThanDirty: Boolean
    $downloaded_after: Date
    $downloaded_before: Date
    $name: String
    $names: [String]
    $bundle_name: String
    $bundleNames: [String]
    $project: String
    $projects: [String]
    $purpose: String
    $report_datetime_after: Date
    $report_datetime_before: Date
    $search: String
    $status: String
    $first: Int
    $after: String
    $last: Int
    $before: String
    $sortBy: DataGridSortableColumns
    $sortDirection: SortDirection
  ) {
    downloads(
      dirty: $dirty
      dirtyEqualsNewDirty: $dirtyEqualsNewDirty
      newDirtyGreaterThanDirty: $newDirtyGreaterThanDirty
      downloaded_after: $downloaded_after
      downloaded_before: $downloaded_before
      name: $name
      names: $names
      bundle_name: $bundle_name
      bundleNames: $bundleNames
      project: $project
      projects: $projects
      purpose: $purpose
      report_datetime_after: $report_datetime_after
      report_datetime_before: $report_datetime_before
      search: $search
      status: $status
      first: $first
      after: $after
      last: $last
      before: $before
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          created
          finished
          handle
          purpose
          progress
          report_datetime {
            short
            long
            long_utc
            iso
          }
          source_tables {
            id
            name
            project
          }
          started
          status
          parts {
            id
            dirty_row_count
            dirty_row_status
            new_dirty_row_count
            new_dirty_row_status
            legacy_flow_source_id
            row_count
            source_table {
              name
              project
            }
            hasConnectedUploadDeclarations
          }
        }
      }
    }
  }
`;

export { DOWNLOAD_FILES_QUERY, DOWNLOAD_QUERY, DOWNLOADS_FOR_FLOW_SE_QUERY };
